const PREFIX = 'wordListUi';
export const SET_DEFAULT_LANGUAGE_COLUMNS = `${PREFIX}/SET_DEFAULT_LANGUAGE_COLUMNS`;
export const SET_LANGUAGE_COLUMNS = `${PREFIX}/SET_LANGUAGE_COLUMNS`;
export const SET_LANGUAGE_COLUMN = `${PREFIX}/SET_LANGUAGE_COLUMN`;
export const RESET_COLUMN = `${PREFIX}/RESET_COLUMN`;